import { Tag, type TagVariant } from '@components';
import { Box, Typography } from '@mui/material';
import type { FC } from 'react';

import { hasStringValue } from '@core/utils/equality';
import { PriceEscalationStatus } from '@core/utils/priceEscalationStatus';

type Props = {
  status: PriceEscalationStatus;
  appliedDetails?: string;
};

export const PriceEscalationStatusTag: FC<Props> = ({ status, appliedDetails }) => {
  const variants: { [key in PriceEscalationStatus]: TagVariant } = {
    [PriceEscalationStatus.Upcoming]: 'Blue',
    [PriceEscalationStatus.Due]: 'Orange',
    [PriceEscalationStatus.Applied]: 'Success',
    [PriceEscalationStatus.NotApplicable]: 'Gray',
  };

  return (
    <Box display='flex' alignItems='center' gap={1} flexWrap='wrap'>
      <Tag variant={variants[status]} label={status} size='sm' />
      {hasStringValue(appliedDetails) && (
        <Typography variant='body2' color='text.secondary'>
          {appliedDetails}
        </Typography>
      )}
    </Box>
  );
};
